import React from 'react'
import { IGroupDetailed } from '../../types/group'
import { StyledAllGroupsTable } from './AllGroupsTable/styled'
import { AllGroupsTableHead, AllGroupsTableRow } from './AllGroupsTable'

export interface IAllGroupsTab {
  groupsList: IGroupDetailed[]
}

export const AllGroupsTab = ({ groupsList }: IAllGroupsTab) => (
  <StyledAllGroupsTable>
    <AllGroupsTableHead />
    <tbody>
      {groupsList.map((group) => (
        <AllGroupsTableRow key={group.name} group={group} />
      ))}
    </tbody>
  </StyledAllGroupsTable>
)
